import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { User } from 'src/app/@shared/modals/user.model';
@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private router: Router, 
        private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let currentUser = this.authService.getCurrentUser();
  
        if (currentUser) {
            return true;
        }
        this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
        
    }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('currentUser')) {
            return true;
        }
        this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } })
        return false;
    }

}
